export default "__VITE_ASSET__DIEkT_H8__"